import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import '../../scss/HomeScreen.scss';

import {
    setCustomList as setCustomListAction,
    setCurrentWordListId as setCurrentWordListIdAction,
    setCurrentGridSize as setCurrentGridSizeAction,
    toggleShuffle as toggleShuffleAction,
} from '../actions'

import WordLists from '../constants/WordLists';
import GridSizes from '../constants/GridSizes';
import store from '../store'

const HomeScreen = ({ onCustomListChange, currentWordListId, onListSelect, currentGridSize, onGridSizeChange, isShuffled, onShuffleChange, customList }) => (
    <div id='mainMenuGridContainer'>
        <div id="title">
            <Link
                id="playButton"
                className='button'
                to={`/wordgrid/game/${currentGridSize}/${currentWordListId}`}
            >
                Play!
            </Link>
        </div>
        
        <div id="listNameMenu">
            <h2>Select a List</h2>
            {Object.entries(WordLists).map(([key, value]) =>
                <span
                    key={key}
                    className={`item button listNameButton ${currentWordListId === value.id ? 'active' : ''}`}
                    onClick={() => onListSelect(key)}
                >
                    {value.listName}
                </span>
            )}
        </div>
        
        <div id="gridSizeMenu">
            <h2>Grid Size</h2>
            <div id="gridSizes">
                {Object.entries(GridSizes).map(([key, value]) =>
                    <span
                        key={key}
                        className={`item button grid-size-button ${currentGridSize === value.id ? 'active' : ''}`}
                        onClick={() => onGridSizeChange(key)}
                    >
                        {value.id}
                    </span>
    
                )}
            </div>
                      
        </div>

        <div id="customSetter">
            {/* Okay to do an onChange event here? */}
            <h2>Custom List</h2>
            <p>(items separated by new lines)</p>
            <textarea
                value={customList}
                onChange={(event) => onCustomListChange(event)}
            ></textarea>
        </div>
        
        <div id='shuffleMenu'>
            <h2>Shuffle the List</h2>
            <span
                id="shuffleButton"
                className={`button ${isShuffled ? 'active' : 'inactive'}`}
                onClick={() => onShuffleChange(!isShuffled)}
            >
                {isShuffled ? 'Shuffled' : 'Unshuffled'}
            </span>
        </div>
    </div>
)

const mapStateToProps = state => ({
    currentWordListId: state.currentWordListIdState,
    currentGridSize: state.currentGridSizeState,
    isShuffled: state.toggleShuffleState,
    customList: state.customListState,
})


const mapDispatchToProps = dispatch => ({
    onListSelect: list => dispatch(setCurrentWordListIdAction(list)),
    onGridSizeChange: gridSize => dispatch(setCurrentGridSizeAction(gridSize)),
    onShuffleChange: shuffled => dispatch(toggleShuffleAction(shuffled)),
    //can I dispatch a state change from within a state change?
    onCustomListChange: function(textAreaEvent) {
        if (store.getState().currentWordListIdState !== 'custom') {
            store.dispatch(setCurrentWordListIdAction('custom'));
        }
        return dispatch(setCustomListAction(textAreaEvent.target.value));
    },
})

export default connect(
    mapStateToProps, 
    mapDispatchToProps,
)(HomeScreen);